import type React from "react";

export const NotFound: React.FC = () => <div>Not found</div>;
